<script setup lang="ts">
import { openModalDisclaimerDisclosure } from 'Components/ModalDisclaimerDisclosure';
import { handleOptOut } from '@/analytics';

function onOpenModalDisclaimerDisclosureClick() {
  openModalDisclaimerDisclosure();
}
</script>

<template>
  <div class="TheFooterBottomLinks footer-bottom-links">
    <a
      href="#"
      class="link-4 small-link footer-bottom-links__link"
      @click.prevent="onOpenModalDisclaimerDisclosureClick"
    >
      Disclosures
    </a>
    <a
      :href="require('doc/AcreTrader.Electronic.Records.and.Signatures.Form.pdf')"
      target="_blank"
      class="link-4 small-link footer-bottom-links__link"
    >
      Consent for Electronic Delivery
    </a>
    <button
      class="link-4 small-link footer-bottom-links__link"
      @click.prevent="handleOptOut"
    >
      Opt Out of Online Tracking
    </button>
  </div>
</template>

<style lang="sass" scoped>
@import '~Styles/_variables'

.footer-bottom-links
  display: flex
  flex-direction: row
  flex-wrap: wrap
  gap: 30px

  @media screen and (max-width: 576px)
    flex-direction: column
    align-items: flex-start

  &__link
    display: inline
    white-space: nowrap
    cursor: pointer
    color: white
    border-bottom: 1px solid white
    font-size: 12px
    font-family: 'Roboto'

    &:hover
      border-bottom-color: transparent

    @media screen and (max-width: 576px)
      margin-bottom: 15px

      &:last-child
        margin-bottom: 0
</style>
